import { HUES, tokens, type Hue } from '@/lib/colour'
import { cx } from './ui'

/** Ten swatches in one even row: each takes a tenth of the width, up to 36px, so a phone never wraps one onto a line of its own. */
export const ColourPicker = ({ value, onChange }: { value?: Hue; onChange: (h: Hue) => void }) => (
  <div className="grid grid-cols-10 gap-1.5 max-w-[22.5rem]" role="radiogroup" aria-label="Colour">
    {HUES.map((h) => (
      <button
        key={h}
        type="button"
        role="radio"
        aria-checked={value === h}
        aria-label={h}
        title={h}
        onClick={() => onChange(h)}
        className={cx(
          'aspect-square w-full max-w-9 rounded-full border-2',
          value === h ? 'border-fg scale-110' : 'border-transparent',
        )}
        style={{ background: tokens(h).accent }}
      />
    ))}
  </div>
)
